export default __webpack_public_path__ + "static/media/arrow_right_red.c9e07a0f.svg";